import "./src/assets/scss/main.scss";
export { wrapRootElement } from "./internal/gatsby/wrap-root-element";

export const onPreRouteUpdate = ({ location }) => {
  const body = document.querySelector("body");
  const elements = document.querySelectorAll(".fadeElement");

  if (elements.length > 0) {
    elements.forEach((el, index) => {
      el.style.transitionDelay = `${index * 0.1}s`; // Stagger delay
      el.classList.add("fadeOut");
    });
  }

  // Ensure navigation happens after the last element fades out
  const maxDelay = elements.length * 0.1 + 0.5; // Adjust base duration (0.5s here)
  setTimeout(() => {
    body.classList.add("fadeOut");
  }, maxDelay * 1000);
};
